const $ = jQuery;

const cSPrefillCalculatorResultsPosting = (campaign) => {
	let field_map = [
		{
			type: "input",
			fieldName: "form-field-name",
			sourceValue: "campaign.name",
		},
		{
			type: "daterange",
			data: {
				startValue: campaign.start_date,
				endValue: campaign.end_date,
			},
			fieldName: "date-range-dynamic-input",
			sourceValue: "campaign.start_date",
		},
		{
			type: "input",
			fieldName: "form-field-in_infeeds",
			sourceValue: "campaign.in_infeeds",
		},
		{
			type: "input",
			fieldName: "form-field-in_reels",
			sourceValue: "campaign.in_reels",
		},
		{
			type: "input",
			fieldName: "form-field-in_stories",
			sourceValue: "campaign.in_stories",
		},
		{
			type: "input",
			fieldName: "form-field-tt_videos",
			sourceValue: "campaign.tt_videos",
		},
		{
			type: "input",
			fieldName: "form-field-tt_stories",
			sourceValue: "campaign.tt_stories",
		},
		{
			type: "input",
			fieldName: "form-field-tt_stories",
			sourceValue: "campaign.tt_stories",
		},
		{
			type: "input",
			fieldName: "form-field-event_hours",
			sourceValue: "campaign.event_hours",
		},
		{
			type: "input",
			fieldName: "form-field-organic_content_months",
			sourceValue: "campaign.organic_content_months",
		},
		{
			type: "checkbox",
			checkCondition: 1,
			fieldNameWhenTrue: "form-field-paid_social-0",
			fieldNameWhenFalse: "form-field-paid_social-1",
			sourceValue: "campaign.paid_social",
		},
		{
			type: "checkbox",
			checkCondition: 1,
			fieldNameWhenTrue: "form-field-digital_media-0",
			fieldNameWhenFalse: "form-field-digital_media-1",
			sourceValue: "campaign.digital_media",
		},
		{
			type: "checkbox",
			checkCondition: 1,
			fieldNameWhenTrue: "form-field-oho-0",
			fieldNameWhenFalse: "form-field-oho-1",
			sourceValue: "campaign.ooh",
		},
		{
			type: "checkbox",
			checkCondition: 1,
			fieldNameWhenTrue: "form-field-broadcasting-0",
			fieldNameWhenFalse: "form-field-broadcasting-1",
			sourceValue: "campaign.broadcasting",
		},
		{
			type: "checkbox",
			checkCondition: 1,
			fieldNameWhenTrue: "form-field-ip_rights-0",
			fieldNameWhenFalse: "form-field-ip_rights-1",
			sourceValue: "campaign.ip_rights",
		},
		{
			type: "checkbox",
			checkCondition: [
				{
					condition: 0,
					fieldWhenConditionMet: "form-field-competitors-0",
				},
				{
					condition: 0.1,
					fieldWhenConditionMet: "form-field-competitors-1",
				},
				{
					condition: 0.5,
					fieldWhenConditionMet: "form-field-competitors-2",
				},
				{
					condition: 0.3,
					fieldWhenConditionMet: "form-field-competitors-3",
				},
			],
			sourceValue: "campaign.competitorMult",
		},
		{
			type: "input",
			fieldName: "form-field-exclusivity-period",
			sourceValue: "campaign.competitorTime",
		},
		{
			type: "input",
			fieldName: "form-field-industry",
			sourceValue: "campaign.industry",
		},
		{
			type: "checkbox",
			checkCondition: 1,
			fieldNameWhenTrue: "form-field-busy-0",
			fieldNameWhenFalse: "form-field-busy-1",
			sourceValue: "campaign.busy",
		},
		{
			type: "checkbox",
			checkCondition: 1,
			fieldNameWhenTrue: "form-field-quick-0",
			fieldNameWhenFalse: "form-field-quick-1",
			sourceValue: "campaign.quick",
		},
		{
			type: "checkbox",
			checkCondition: 1,
			fieldNameWhenTrue: "form-field-giveaway-0",
			fieldNameWhenFalse: "form-field-giveaway-1",
			sourceValue: "campaign.giveaway",
		},
		{
			type: "input",
			fieldName: "form-field-pocket",
			sourceValue: "campaign.pocket",
		},
		{
			type: "input",
			fieldName: "form-field-ig_followers",
			sourceValue: "campaign.ig_followers",
		},
		{
			type: "input",
			fieldName: "form-field-tt_followers",
			sourceValue: "campaign.tt_followers",
		},
		{
			type: "input",
			fieldName: "form-field-ig_er",
			sourceValue: "campaign.ig_er",
		},
		{
			type: "checkbox",
			checkCondition: 1,
			fieldNameWhenTrue: "form-field-is_pro-0",
			fieldNameWhenFalse: "form-field-is_pro-1",
			sourceValue: "campaign.is_pro",
		},
		{
			type: "checkbox",
			checkCondition: 1,
			fieldNameWhenTrue: "form-field-is_quality-0",
			fieldNameWhenFalse: "form-field-is_quality-1",
			sourceValue: "campaign.is_quality",
		},
		{
			type: "input",
			fieldName: "form-field-ig_story_vr",
			sourceValue: "campaign.ig_story_vr",
		},
		{
			type: "input",
			fieldName: "form-field-tt_video_vr",
			sourceValue: "campaign.tt_video_vr",
		},
		{
			type: "input",
			fieldName: "form-field-tt_story_vr",
			sourceValue: "campaign.tt_story_vr",
		},
		{
			type: "checkbox",
			checkCondition: 0.5,
			fieldNameWhenTrue: "form-field-opt_in-0",
			fieldNameWhenFalse: "form-field-opt_in-1",
			sourceValue: "campaign.opt_in",
		},
	];

	field_map.forEach((element) => {
		const [objectName, key] = element.sourceValue.split(".");
		const dataObject = eval(objectName);
		const dataValue = dataObject[key];
		switch (element.type) {
			case "checkbox":
				if ("object" == typeof element.checkCondition) {
					// loop on conditions and check the correct one
					element.checkCondition.forEach((checkConditionItem) => {
						if ($("#" + checkConditionItem.fieldWhenConditionMet).length) {
							if (dataValue == checkConditionItem.condition) {
								$("#" + checkConditionItem.fieldWhenConditionMet).prop(
									"checked",
									true
								);
							}
						}
					});
				} else {
					// default checkbox true or false only
					if (dataValue == element.checkCondition) {
						if ($("#" + element.fieldNameWhenTrue).length) {
							$("#" + element.fieldNameWhenTrue).prop("checked", true);
						}
					} else {
						if ($("#" + element.fieldNameWhenFalse).length) {
							$("#" + element.fieldNameWhenFalse).prop("checked", true);
						}
					}
				}
				break;
			case "daterange":
				csUpdateDateRangePickers(element.data.startValue, element.data.endValue);
				break;
			case "input":
			default:
				if ($("#" + element.fieldName).length) {
					document.getElementById(element.fieldName).value = dataValue;
					break;
				}
		}
	});
};
export default cSPrefillCalculatorResultsPosting;
